"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cache = void 0;
var Cache = /** @class */ (function () {
    function Cache(options) {
        this.cache = new Map();
        this.options = options || { sweepInterval: 100 };
        if (this.options.idleDurationMs != undefined && this.options.idleDurationMs <= 0) {
            throw new Error('Idle duration must be positive');
        }
        this.interval = this.options.sweepInterval || 100;
        if (this.interval <= 0) {
            throw new Error('Sweep interval must be a positive number');
        }
    }
    Cache.prototype.put = function (key, value, time, expireCallback, idleDurationMs) {
        if (time === undefined || time === null || time <= 0) {
            throw new Error('Cache timeout must be a positive number');
        }
        if (idleDurationMs === undefined || idleDurationMs === null || idleDurationMs <= 0) {
            idleDurationMs = this.options.idleDurationMs;
        }
        var record = {
            value: value,
            lastUsed: idleDurationMs ? Date.now() : undefined,
            expire: time + Date.now(),
            idleDurationMs: idleDurationMs,
            expireCallback: expireCallback
        };
        this.cache.set(key, record);
        if (!this.timeout) {
            this.timeout = setInterval(this.onInterval.bind(this), this.interval);
            // In node.js, this timer should be .unref'd.
            // This function doesn't exist in the client
            if (this.timeout.unref) {
                this.timeout.unref();
            }
        }
        return value;
    };
    Cache.prototype.del = function (key) {
        if (this.options.delCallback) {
            var record = this.cache.get(key);
            if (record) {
                this.options.delCallback(key, record.value);
            }
        }
        var retVal = this.cache.delete(key);
        // Turn off the timer
        if (this.size() === 0) {
            this.clear();
        }
        return retVal;
    };
    Cache.prototype.clear = function () {
        if (this.timeout) {
            clearInterval(this.timeout);
            this.timeout = undefined;
        }
        this.cache.clear();
    };
    Cache.prototype.get = function (key) {
        var record = this.cache.get(key);
        if (record) {
            if (this.options.idleDurationMs) {
                record.lastUsed = Date.now();
            }
            return record.value;
        }
        return undefined;
    };
    /**
     * Does not work for IE. You will need a polyfill for Map if you want to use this on IE.
     * Use forEach instead.
     */
    Cache.prototype.keys = function () {
        return this.cache.keys();
    };
    Cache.prototype.forEach = function (cb) {
        this.cache.forEach(function (record, key) {
            cb(record.value, key);
        });
    };
    Cache.prototype.size = function () {
        return this.cache.size;
    };
    Cache.prototype.updateExpireTime = function (key, timeToLive) {
        if (this.cache.has(key) && timeToLive >= 0) {
            this.cache.get(key).expire = timeToLive + Date.now();
            return true;
        }
        return false;
    };
    Cache.prototype.onInterval = function () {
        var _this = this;
        var now = Date.now();
        this.cache.forEach(function (record, key) {
            if (record.idleDurationMs) {
                if (record.lastUsed < now - record.idleDurationMs) {
                    _this.del(key);
                    if (_this.options.idleCallback) {
                        _this.options.idleCallback(key, record.value);
                    }
                    return; // Ensure we don't fire an expire callback
                }
            }
            if (record.expire < now) {
                _this.del(key);
                if (record.expireCallback) {
                    record.expireCallback(key, record.value);
                }
            }
        });
    };
    return Cache;
}());
exports.Cache = Cache;
//# sourceMappingURL=cache.js.map